import React from 'react';
import { Tracking } from 'web-core/src/tracking';

import Button from 'client/components/button/button';
import conf from 'client/conf';
import Hero from 'client/components/account/hero';
import Translate from 'client/components/translate';
import PROVISION_ENABLE from 'client/constants/enterpriseProvision';
import { handle422Error, handleRedirect } from 'routes/join/utils/index';
import { WEB_CLICK_PROVISION } from 'routes/join/constants/tracking';
import type { LocationType, RouterType } from 'types/react-router.flow';

const PARTNER_PREFIX = 'partner.enterprise.account.loggedIn';

type Props = {
  brand: string,
  code: string | null,
  email: string,
  firstName: string | null,
  id: string | null,
  isProvisioned: boolean,
  location: LocationType,
  logout: Function,
  provision: Function,
  redirect: ?string,
  router: RouterType,
  siteConfigs: Object,
  user_id: string,
};

class LoggedInPage extends React.PureComponent<Props> {
  static defaultProps = {
    code: null,
  };

  clickHandler = (e: SyntheticEvent<>) => {
    const { brand, code, isProvisioned, redirect, router, user_id, id } = this.props;
    e.preventDefault();

    // checking provision when no redirect route or provision for that route is enabled
    if (!redirect || PROVISION_ENABLE[redirect]) {
      return this.props
        .provision({
          code,
          id,
          source: `enterprise-${brand}`,
        })
        .then(({ data }) => {
          handleRedirect(redirect, user_id, data, router);
        })
        .catch(err => handle422Error(isProvisioned, err, router, redirect))
        .finally(() => {
          Tracking.track(WEB_CLICK_PROVISION, { type: 'continue', client: brand });
        });
    }
    const data = {};
    return handleRedirect(redirect, user_id, data, router);
  };

  logOutHandler = (e: SyntheticEvent<>) => {
    e.preventDefault();
    const { location, router } = this.props;
    return this.props.logout().then(() => {
      router.replace({
        pathname: '/login',
        query: location.query,
      });
    });
  };

  render() {
    const { brand, email, firstName, siteConfigs } = this.props;
    return (
      <div className="account-page text-center">
        <Hero brandName={brand} siteConfigs={siteConfigs} />
        <div className="center-col-small">
          <img
            alt=""
            className="illustration margin"
            src={`${conf.CONTENTFUL_SPACE_URL}/4VAv4JSxTa4amAkM2Yus4I/f8081eaf97450c89bd24b7eb040d8da1/stars.svg`} />
          <div className="margin-2">
            <h3>
              <Translate
                path={`${PARTNER_PREFIX}.header${firstName ? 'WithName' : ''}`}
                using={{ firstName }} />
            </h3>
            <p className="pad-bottom margin-top">({email})</p>
            <p>
              <Translate path={`${PARTNER_PREFIX}.subheader`} />
            </p>
          </div>
          <Button className="cta-button" clickHandler={this.clickHandler}>
            <Translate path="common.cta.continue" />
          </Button>
          <p className="pad-y">
            <Translate path={`${PARTNER_PREFIX}.changeCta`} />
            <button className="accessible-link" onClick={this.logOutHandler}>
              <Translate path={`${PARTNER_PREFIX}.changeCtaLink`} />
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default LoggedInPage;
